<div mat-dialog-content>{{message}}</div>
<div class="dialog-footer-2">
	<button mat-button (click)="onNoClick()">Cancelar</button>
	<button mat-button [mat-dialog-close]="true" cdkFocusInitial>Confirmar</button>
</div>
